module.exports = __webpack_public_path__ + "20250721160708/img/invite_bj.b834b74f.png";